"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncoderVisitor = void 0;
const ast_1 = require("@wapc/widl/ast");
const helpers_1 = require("./helpers");
class EncoderVisitor extends ast_1.BaseVisitor {
    constructor(writer) {
        super(writer);
    }
    visitTypeFieldsBefore(context) {
        super.triggerTypeFieldsBefore(context);
        this.write(`  encode(encoder: Writer): void {
    encoder.writeMapSize(${context.fields.length});\n`);
    }
    visitTypeField(context) {
        const field = context.field;
        this.write(`encoder.writeString(${helpers_1.strQuote(field.name.value)});\n`);
        this.write(helpers_1.encode("this." + field.name.value, field.type, helpers_1.isReference(field.annotations)));
        super.triggerTypeField(context);
    }
    visitTypeFieldsAfter(context) {
        this.write(`  }\n`);
        super.triggerTypeFieldsAfter(context);
    }
}
exports.EncoderVisitor = EncoderVisitor;
//# sourceMappingURL=encoder_visitor.js.map